// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextWednesday as fn } from "../nextWednesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextWednesdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default nextWednesdayWithOptions;
